import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PremissasUsuario } from 'src/app/models/premissas-usuario';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-inserir-valor-modal',
  templateUrl: './inserir-valor-modal.component.html',
  styleUrls: ['./inserir-valor-modal.component.scss']
})
export class InserirValorModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  premissasUsuario = new PremissasUsuario();

  valor;

  valorArredondamento;
  valorAnterior;
  valorMinimo;
  valorSemDesconto;

  public MASKS = MASKS;

  constructor(
    public dialogRef: MatDialogRef<InserirValorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private premissasService: PremissasService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService
  ) {
    this.valorArredondamento = data.valorArredondamento;
    this.valorAnterior = data.valorAnterior;
    this.valorMinimo = data.valorMinimo;
    this.valorSemDesconto = data.valorSemDesconto;
  }

  ngOnInit() {
    this.buscarPremissasUsuario();
  }

  buscarPremissasUsuario() {
    this.carregandoService.mostra('buscarPremissasUsuario');

    this.premissasService.consultarPremissasUsuario().subscribe(
      (premissas) => {
        this.premissasUsuario = premissas;
        this.carregandoService.esconde('buscarPremissasUsuario');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasUsuario');
        this.notificacaoService.erro(erro);
      }
    );
  }

  excedeLimiteArredondamento(): boolean {
    const limite = Number(this.premissasUsuario.limiteArredondamentoReais);

    if (!(limite > 0)) {
      return false;
    }

    const valor = Number(this.valor);
    return !isNaN(valor) && Math.abs(valor - this.valorAnterior) > limite;
  }

  conferir() {
    this.valor = Number(this.valor);

    if (this.excedeLimiteArredondamento()) {
      swal({
        title: 'Atenção!!!',
        text: 'Valores não estão permitidos. O valor do arredondamento excede o limite máximo configurado.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      });
      return;
    }

    if (this.valor >= this.valorMinimo && this.valor <= this.valorSemDesconto) {
      this.dialogRef.close(this.valor !== this.valorAnterior ? this.valor : undefined);
    }
  }

  fechar() {
    this.dialogRef.close();
  }
}
